<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [dataLabels]="chartOptions.dataLabels!"
        [markers]="chartOptions.markers!"
        [xaxis]="chartOptions.xaxis!"
        [grid]="chartOptions.grid!"
        [yaxis]="chartOptions.yaxis!"
        [stroke]="chartOptions.stroke!"
        [colors]="chartOptions.colors!"
        [title]="chartOptions.title!"
    ></apx-chart>
</div>